<script>
  import {
    VTextarea
  } from 'vuetify/lib'
  export default {
    name: 'wh-textarea',
    extends: VTextarea
  };
</script>